<app-smart-input-entity
  fieldLabel="name"
  [control]="control()"
  [handler]="workPackagePickerHandler()"
  [placeholder]="placeholder()"
  [resetValue]="resetValue()">
  <ng-template
    let-item="item"
    appTemplate="filter">
    @if (cast(item); as priority) {
      <app-wp-priority-badge
        class="flex w-full max-w-full"
        [wpPriority]="{
          name: priority.name,
          color: priority.color.text,
          icon: priority.icon ?? undefined
        }" />
    }
  </ng-template>
</app-smart-input-entity>
